<div class="custom-text-field" [style]="{ width: '100%' }">
  <div
    class="custom-text-field__input"
    [style]="{ width: width + widthUnit, 'border-color': focusBorder }"
    [title]="
      type !== 'password'
        ? value && value.toString().length > 0
          ? value
          : placeholder
        : ''
    "
    [ngClass]="{
      'custom-text-field__input--disabled': disabled,
      'custom-text-field__input--readonly': readOnly && !disabled,
      'custom-text-field__input--warning': toolTipMessage && !focusBorderToolTip
    }"
    #InputField
  >
    <div
      class="custom-text-field__input-field-title-text"
      [ngClass]="{
        cursorIcon: iconClicked,
        'custom-text-field__input-field-title-text__required': required
      }"
      *ngIf="
        fieldTitle !== '' && fieldTitle !== undefined && fieldTitle !== null
      "
    >
      {{ fieldTitle }}:
    </div>
    <div
      class="custom-text-field__input-prefix-container"
      *ngIf="
        prefixText !== '' && prefixText !== undefined && prefixText !== null
      "
    >
      <span class="custom-text-field__input-prefix-text">{{ prefixText }}</span>
    </div>
    <input
      *ngIf="!commaSeparator"
      [id]="'noscrol_' + randomNumber"
      class="custom-text-field__input-field noscroll"
      [placeholder]="placeholder"
      [type]="(type === 'mobile' || type === 'alphaNumeric' || type==='numberOnly' || type==='registrationNumber') ? 'text' : type"
      [(ngModel)]="value"
      (copy)="onCopy()"
      (ngModelChange)="onUpdate($event)"
      (keyup)="validateInput()"
      (keydown)="type == 'number' ? onlyNumber($event) : onKeyDown($event)"
      [readOnly]="readOnly || disableEdit"
      (blur)="handleBlur()"
      (focus)="setBorderhighlight()"
      [title]="
        value && type !== 'password' && value.toString().length > 0
          ? value
          : !(fieldTitle && type !== 'password')
          ? placeholder
          : ''
      "
      aria-label="text field"
      [ngClass]="{
        'custom-text-field__input-field--pl-0':
          selectDropdownConfig || fieldTitle,
        'custom-text-field__suffix-field': suffixText,
        'custom-text-field__input-field--container': suffixText,
        'custom-text-field__input-field--alignment': isCentreAlign,
        'custom-text-field__input-field--warning':
          toolTipMessage && !focusBorderToolTip
      }"
      [ngStyle]="{
        'pointer-events': disableInput || disabled ? 'none' : 'auto',
        'background-color': fieldColor,
        'border-color': focusBorder
      }"
      maxlength="{{ maxLength }}"
      [disabled]="disabled"
      (keyup.enter)="enterClicked($event)"
      [attr.tabindex]="disableInput || disabled ? '-1' : '0'"
      (keypress)="restrictDecimal ? ($event.key === '.' ? $event.preventDefault() : null) : ((type === 'number' || type==='numberOnly') ? restrictInputNumberToLimit($event) : null)"
      (input)="validateInputType($event)"
    />

    <div
      class="custom-text-field__input-suffix-container"
      *ngIf="
        suffixText !== '' && suffixText !== undefined && suffixText !== null
      "
    >
      <span class="custom-text-field__input-suffix-text">{{ suffixText }}</span>
    </div>

    <input
      aria-label="text field"
      *ngIf="commaSeparator"
      class="custom-text-field__input-field noscroll"
      [placeholder]="!fieldTitle ? placeholder : ''"
      [type]="type"
      [ngModel]="formatValue(this.value)"
      (keyup)="validateInput()"
      (keydown)="type == 'number' ? onlyNumber($event) : ''"
      (ngModelChange)="onUpdate($event)"
      [readOnly]="readOnly || disableEdit"
      [title]="
        value && value.toString().length > 0
          ? value
          : !fieldTitle
          ? placeholder
          : ''
      "
      [ngClass]="{
        'custom-text-field__input-field--pl-0': selectDropdownConfig
      }"
      maxlength="{{ maxLength }}"
      (blur)="handleBlur()"
      (focus)="setBorderhighlight()"
      [disabled]="disabled"
      customCommaSeparator="commaSeparator ? true : false"
      (keyup.enter)="enterClicked($event)"
      [attr.aria-label]="formatValue(this.value)"
    />

    <div
      class="custom-text-field__input-icon"
      [ngClass]="{
        cursorIcon: iconClicked,
        pointerdisabled: disabled || readOnly
      }"
      *ngIf="
        suffixIcon !== '' && suffixIcon !== undefined && suffixIcon !== null
      "
      [ngStyle]="{
        'background-image': 'url(' + suffixIcon + ')',
        width: iconWidth,
        'min-width': iconWidth,
        height: iconHeight,
        'min-height': iconHeight,
        opacity: readOnly ? 0.3 : 1
      }"
      [attr.tabindex]="readOnly || disabled ? '-1' : '0'"
      aria-label="icon"
      role="button"
      (keyup.enter)="iconClick()"
      (click)="iconClick()"
    ></div>
  </div>
  <div
    class="custom-text-field__tooltip {{ tooltipDirection }}"
    *ngIf="toolTipMessage.length > 0 && showError"
  >
    <div
      class="custom-text-field__tooltip_message"
      [style]="{
        width: tooltipWidth + tooltipWidthUnit,
        height: tooltipHeight + 'px'
      }"
    >
      {{ toolTipMessage }}
    </div>
  </div>
</div>
